import { useState, useRef, Suspense } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { Points, PointMaterial, Preload } from "@react-three/drei";
import * as random from "maath/random/dist/maath-random.esm";

const Stars = (props) => {
  const ref_1 = useRef();
  const ref_2 = useRef();
  const [sphere_1] = useState(() => random.inSphere(new Float32Array(15000), { radius: 1.2 }));
  const [sphere_2] = useState(() => random.inSphere(new Float32Array(15000), { radius: 1.2 }));

  useFrame((state, delta) => {
    ref_1.current.rotation.x -= delta / 10;
    ref_1.current.rotation.y -= delta / 15;
  });

  useFrame((state, delta) => {
    ref_2.current.rotation.x -= delta / 10;
    ref_2.current.rotation.y -= delta / 15;
  });

  return (
    <group rotation={[0, 0, Math.PI / 4]}>
      <Points ref={ref_1} positions={sphere_1} stride={3} frustumCulled {...props}>
        <PointMaterial
          transparent
          color='#15436A'//'#19c6d2'//'#7c8d24'// color='#f272c8'
          size={0.001} //0.002
          sizeAttenuation={true}
          depthWrite={false}
        />
      </Points>

      <Points ref={ref_2} positions={sphere_2} stride={3} frustumCulled {...props}>
        <PointMaterial
          transparent
          color='#ef3e0b'//'#7c8d24'// color='#f272c8'
          size={0.001} //0.002
          sizeAttenuation={true}
          depthWrite={false}
        />
      </Points>
    </group>
  );
};

const StarsCanvas = () => {
  return (
    <div className='w-full h-auto absolute inset-0 z-[-1]'>
      <Canvas camera={{ position: [0, 0, 1] }}>
        <Suspense fallback={null}>
          <Stars />
        </Suspense>

        <Preload all />
      </Canvas>
    </div>
  );
};

export default StarsCanvas;